import LocalStorageServices from './LocalStorageServices';

export default LocalStorageServices;